var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnDelete = function SvgBtnDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EDEDEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.066 9.066a.8.8 0 0 0-1.132-1.132l1.132 1.132Zm-8.132 5.868a.8.8 0 0 0 1.132 1.132l-1.132-1.132Zm7 1.132a.8.8 0 0 0 1.132-1.132l-1.132 1.132ZM9.066 7.934a.8.8 0 0 0-1.132 1.132l1.132-1.132Zm5.868 0-7 7 1.132 1.132 7-7-1.132-1.132Zm1.132 7-7-7-1.132 1.132 7 7 1.132-1.132Z",
    fill: "#A4A7AD"
  })));
};
export default SvgBtnDelete;